import { render, staticRenderFns } from "./PlayView.vue?vue&type=template&id=118d1a96&scoped=true&"
import script from "./PlayView.vue?vue&type=script&lang=js&"
export * from "./PlayView.vue?vue&type=script&lang=js&"
import style0 from "./PlayView.vue?vue&type=style&index=0&id=118d1a96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118d1a96",
  null
  
)

export default component.exports